import React, { Component } from "react";
import { connect } from "react-redux";

import { OFFERLIST, CAN_USE_VENDOR_OFFERS, hasPermission } from "../../utils/permissons";

import ReactPaginate from "react-paginate";
import queryString from "query-string";

import Spinner from "../../components/generics/Spinner";
import Filter from "../../components/generics/Filter";
import ListHeader from "../../components/generics/ListHeader";

import Alert from "../../utils/Alert";
import Modal from "../../components/generics/Modal";

import { isMarketUser } from "../../utils/AuthService";

import { STARTING_PAGE } from "../../constants/constants";

import { purchaseOrderStatusOptions, marketPurchaseOrderStatusOptions } from "../../utils/Helpers";

import { fetchVendors, fetchVendorsSuccess, fetchVendorsFailure } from "../../store/invoices/actions";

import { fetchPurchaseOrders, fetchPurchaseOrdersSuccess, fetchPurchaseOrdersFailure } from "../../store/purchaseOrders/actions";

import { deletePurchaseOrder } from "../../store/purchaseOrders/api";

import PurchaseOrderList from "../../components/purchaseOrders/PurchaseOrderList";
import { withRouter } from "utils/WithRouter";

export class PurchaseOrderListContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      purchaseOrderId: "",
      date: "",
      status: undefined,
      selectedStatus: undefined,
      vendor: undefined,
      openDeleteModal: false,
      purchaseOrderToDelete: undefined,
    };

    this.alertRef = React.createRef();
  }

  componentDidMount() {
    this.props.fetchVendors();

    const params = queryString.parse(this.props.location.search);
    const page = params.page ? params.page : STARTING_PAGE;
    const date = params.date ? params.date : "";
    const vendor = params.vendor ? params.vendor : undefined;
    const purchaseOrderId = params.purchaseOrderId ? params.purchaseOrderId : undefined;
    const status = params.status ? params.status : params.selectedStatus === "-1" ? undefined : isMarketUser() ? 2 : 1;

    this.setState({ page, purchaseOrderId, vendor, date, status }, () => {
      this.props.fetchPurchaseOrders(page, purchaseOrderId, vendor, status, date);
    });
  }

  // ---------------------------------------------------------------------------
  // Filters
  // ---------------------------------------------------------------------------
  onPurchaseOrderIdChanged = (event) => {
    const purchaseOrderId = event.target.value ? event.target.value : "";
    this.setState({ purchaseOrderId, page: STARTING_PAGE }, () => {
      this.filterList();
    });
  };

  onDateChange = (event) => {
    const date = event.target.value ? event.target.value : "";
    this.setState({ date, page: STARTING_PAGE }, () => {
      this.filterList();
    });
  };

  onStatusChange = (event) => {
    const selectedStatus = event.target.value ? event.target.value.toString() : undefined,
      status = selectedStatus && selectedStatus !== "-1" ? selectedStatus : undefined;
    this.setState({ selectedStatus, status, page: STARTING_PAGE }, () => {
      this.filterList();
    });
  };

  onVendorChange = (event) => {
    const vendor = event.target.value && event.target.value > -1 ? event.target.value : undefined;
    this.setState({ vendor, page: STARTING_PAGE }, () => {
      this.filterList();
    });
  };

  filterList = () => {
    let params = {};
    params.page = this.state.page;

    if (this.state.purchaseOrderId) {
      params.purchaseOrderId = this.state.purchaseOrderId;
    }
    if (this.state.date) {
      params.date = this.state.date;
    }
    if (this.state.selectedStatus) {
      params.selectedStatus = this.state.selectedStatus;
    }
    if (this.state.vendor) {
      params.vendor = this.state.vendor;
    }
    this.props.history.push({
      search: queryString.stringify(params),
    });
    this.props.fetchPurchaseOrders(this.state.page, this.state.purchaseOrderId, this.state.vendor, this.state.status, this.state.date);
  };

  handleDeleteModal = (purchaseOrderId) => {
    this.setState({ purchaseOrderToDelete: purchaseOrderId });
    this.setState({ openDeleteModal: true });
  };

  handleDelete = (purchaseOrderId) => {
    deletePurchaseOrder(purchaseOrderId).then(
      () => {
        this.alertRef.current.sendAlert(`Purchase Order #${purchaseOrderId} has been deleted successfully`, "success");
        // Refresh Purchase Order List
        this.props.fetchPurchaseOrders(this.state.page, this.state.purchaseOrderId, this.state.vendor, this.state.status, this.state.date);
      },
      () => {
        this.alertRef.current.sendAlert(`Purchase Order #${purchaseOrderId} couldn't be deleted`);
      }
    );
    this.setState({ openDeleteModal: false });
  };

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let page = data.selected + 1;
    if (page !== this.state.page) {
      this.setState({ page }, () => {
        this.filterList();
      });
    }
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    if (!this.props.purchaseOrdersList.purchaseOrders) {
      return <Spinner />;
    }
    return (
      <div className="animated fadeIn">
        <Alert ref={this.alertRef} />
        <div className="card">
          <ListHeader
            dark
            showAction={false}
            title="Purchase Orders"
            iconClass="fa fa-wpforms mr-05"
            buttons={[
              hasPermission(OFFERLIST, CAN_USE_VENDOR_OFFERS) && {
                buttonTitle: "Order by best price",
                actionLink: "/purchase_orders_by_price/new",
                buttonClass: "btn btn-primary m-0 mr-1",
              },
              !isMarketUser() && {
                buttonTitle: "Order by Vendor",
                actionLink: "/purchase_orders/new",
                buttonClass: "btn btn-primary m-0",
              },
            ]}
          />
          <Filter
            searchLabel="Purchase Order ID"
            searchPlaceholder="Purchase Order ID"
            searchVal={this.state.purchaseOrderId}
            onSearchChange={this.onPurchaseOrderIdChanged}
            dateLabel="Date"
            dateVal={this.state.date}
            onDateChange={this.onDateChange}
            dropdownLabel="Status"
            dropdownPlaceholder="Select order status"
            dropdownVal={this.state.status}
            onDropdownChange={this.onStatusChange}
            dropdownByElementId
            dropdownOptions={isMarketUser() ? marketPurchaseOrderStatusOptions : purchaseOrderStatusOptions}
            dropdownLabel2="Vendor"
            dropdownPlaceholder2="Select vendor"
            dropdownVal2={this.state.vendor}
            onDropdownChange2={this.onVendorChange}
            dropdownByElementId2
            dropdownOptions2={this.props.vendorsList ? this.props.vendorsList.vendors.results : []}
            colClass="col-12 col-sm-3"
          />
        </div>
        <div className="card">
          <div className="card-block p-0">
            <table className="table table-striped table-bordered datatable mb-0">
              <thead>
                <tr>
                  <th className="hidden-xs-down">ID</th>
                  <th>Vendor</th>
                  <th className="hidden-md-down">Invoice</th>
                  <th className="hidden-md-down">Date</th>
                  <th>Delivery Date</th>
                  <th className="hidden-xs-down">Num Items</th>
                  <th className="hidden-xs-down">Created By</th>
                  <th className="hidden-xs-down">Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <Modal
                closeModal={() => this.setState({ openDeleteModal: false })}
                isModalOpen={this.state.openDeleteModal}
                onConfirm={() => this.handleDelete(this.state.purchaseOrderToDelete)}
                onCancel={() => this.setState({ openDeleteModal: false })}
                header="Delete Purchase Order"
                content={`Are you sure you want to delete Purchase Order #${this.state.purchaseOrderToDelete}?`}
                onConfirmButtonText="Yes"
                onCancelButtonText="No"
              />
              <PurchaseOrderList
                purchaseOrders={this.props.purchaseOrdersList.purchaseOrders}
                statusOptions={purchaseOrderStatusOptions}
                handleDelete={this.handleDeleteModal}
              />
            </table>
            {this.props.purchaseOrdersList.pages > 1 && (
              <ReactPaginate
                pageCount={this.props.purchaseOrdersList.pages}
                pageRangeDisplayed={2}
                marginPagesDisplayed={1}
                previousLabel="<"
                nextLabel=">"
                onPageChange={this.handlePageRequest}
                initialPage={this.state.page - 1}
                disableInitialCallback={true}
                containerClassName="pagination"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                activeClassName="page-item active"
                previousClassName="paginate_button previous"
                nextClassName="paginate_button next"
                disabledClassName="page-item disabled"
                forcePage={this.state.page - 1}
              />
            )}
          </div>
        </div>
        {this.props.purchaseOrdersList.loading ? <Spinner /> : null}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    purchaseOrdersList: state.purchaseOrders.purchaseOrdersList,
    vendorsList: state.invoices.vendorsList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPurchaseOrders: (page, purchaseOrderId, vendor, status, date) => {
      dispatch(fetchPurchaseOrders(page, purchaseOrderId, vendor, status, date)).payload.then(
        (response) => {
          dispatch(fetchPurchaseOrdersSuccess(response.data));
        },
        (error) => {
          dispatch(fetchPurchaseOrdersFailure(error));
        }
      );
    },
    fetchVendors: () => {
      dispatch(fetchVendors()).payload.then(
        (response) => {
          dispatch(fetchVendorsSuccess(response.data));
        },
        (error) => {
          dispatch(fetchVendorsFailure(error));
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseOrderListContainer));
